import { type FC } from 'react';

import { HelperText } from '@craft/ui/components/input';

import { type CollaborativeRap } from '../../types';

export const selectedRapHasTags = (selectedRap: CollaborativeRap) =>
  selectedRap.competencyTagGroups.some(group => group.tags.length > 0) ||
  selectedRap.ungroupedCompetencyTags.length > 0;

interface CompetencyTaggingDropdownHelperTextProps {
  readonly selectedRap: CollaborativeRap | null;
}

export const CompetencyTaggingDropdownHelperText: FC<CompetencyTaggingDropdownHelperTextProps> = ({
  selectedRap,
}) => {
  if (!selectedRap || !selectedRapHasTags(selectedRap)) {
    return (
      <HelperText>
        {selectedRap
          ? 'No competency tags available for this RAP.'
          : 'Choose a RAP to load competency list.'}
      </HelperText>
    );
  }
  return null;
};
